// Internal Dependencies:
import { insertIntoObjectAfterKey } from 'church-theme-library/utilities/objects'

const initialState = {
	dkePageData: {},
	isLoading: false,

	// Page/single:
	receivedPageDataCache: {},
	selected: false,
	currentlyViewedPage: false,
	pageViewsRegisteredIds: [], // The pages which have been seen by this user in this session.
	byId: {},

	// Archive:
	selectedArchive: false,
	archiveCategoriesById: {},

	loadingById: {},
	appendedById: {},

	numberOfPosts: 0,
	showSetA: false,
	showSetZ: false,
	postsSetA: [],
	postsSetZ: [],

	numberOfSermonSeries: 0,
	showSermonSeriesSetA: false,
	showSermonSeriesSetZ: false,
	sermonSeriesSetA: [],
	sermonSeriesSetZ: [],

	selectedDateYear: 'all',
	selectedDateMonth: 'all',

	// Social:
	facebookFeedById: {},
	instagramFeedById: {},
	facebookFeedReceived: false,
	instagramFeedReceived: false
}

function getSetANumber( type ) {
	switch ( type ) {
		case 'posts':
			return siteData.posts_set_a_number.posts

		case 'events':
			return siteData.posts_set_a_number.events

		case 'sermons':
			return siteData.posts_set_a_number.sermons

		case 'sermon-series':
			return siteData.posts_set_a_number['sermon-series']

		case 'speakers':
			return siteData.posts_set_a_number.speakers

		case 'bulletins':
			return siteData.posts_set_a_number.bulletins

		case 'galleries':
			return siteData.posts_set_a_number.galleries

		case 'resources':
		case 'resources-category':
			return siteData.posts_set_a_number.resources

		case 'ministries':
			return siteData.posts_set_a_number.ministries
	}

	return 4
}

export default function pageReducer( state = initialState, action ) {
	const { type, payload } = action
	let theId,
		newLoadingById,
		newById,
		newPostCategoriesById,
		newSelected,
		newSelectedArchive,
		newPostsSetA,
		newPostsSetZ,
		newSermonSeriesSetA,
		newSermonSeriesSetZ,
		newSectionsData,
		prevSectionsData,
		prevSectionsKeys,
		newSectionsKeys,
		prevSectionData,
		dkePageData

	switch ( type ) {
		case 'REQUEST_PAGE_DATA':
			let isLoading = payload.requestOnly ? state.isLoading : true
			newLoadingById = {
				...state.loadingById
			}

			if ( 'more' == payload.type ) {
				newLoadingById = {
					...state.loadingById,
					morePosts: true
				}
			} else {
				newLoadingById = {
					...state.loadingById,
					[ payload.slug ]: true
				}
			}

			return {
				...state,
				isLoading: isLoading,
				error: false,
				loadingById: newLoadingById
			}

		case 'RECEIVE_PAGE_DATA_RESPONSE_FOR_CACHE':
			return {
				...state,
				receivedPageDataCache: {
					...state.receivedPageDataCache,
					[ payload.requestId ]: payload.json
				}
			}

		case 'RECEIVE_PAGE_DATA':
			newById = {
				...state.byId
			}
			newPostCategoriesById = {
				...state.archiveCategoriesById
			}
			newLoadingById = {
				...state.loadingById
			}
			theId = payload.type ? `id_${payload.type}_${payload.slug}` : `id_${payload.slug}`

			if (
				'posts' == payload.type ||
				'events' == payload.type ||
				'sermons' == payload.type ||
				'sermon-series' == payload.type ||
				'speakers' == payload.type ||
				'bulletins' == payload.type ||
				'galleries' == payload.type ||
				'resources' == payload.type ||
				'ministries' == payload.type
				) {

				newLoadingById = {
					...state.loadingById,
					[ theId ]: false
				}

				if ( newPostCategoriesById[ theId ] ) {
					newPostCategoriesById[ theId ] = payload.data
				} else {
					newPostCategoriesById = {
						[ theId ]: payload.data,
						...state.archiveCategoriesById
					}
				}
			} else if ( 'more' == payload.type ) {
				newLoadingById = {
					...state.loadingById,
					morePosts: false
				}

				if ( newPostCategoriesById[ `id_${payload.subType}_${payload.slug}` ] ) {
					newPostCategoriesById[ `id_${payload.subType}_${payload.slug}` ].items = {
						...newPostCategoriesById[ `id_${payload.subType}_${payload.slug}` ].items,
						...payload.data.items
					}
				}
			} else {
				newLoadingById = {
					...state.loadingById,
					[ theId ]: false
				}

				if ( newById[ theId ] ) {
					newById[ theId ] = payload.data
				} else {
					newById = {
						[ theId ]: payload.data,
						...state.byId
					}
				}
			}

			return {
				...state,
				isLoading: false,
				error: false,
				byId: newById,
				archiveCategoriesById: newPostCategoriesById,
				loadingById: newLoadingById
			}

		case 'RECEIVE_PARTIAL_PAGE_DATA':
			dkePageData = state.dkePageData
			theId = payload.type ? `id_${payload.type}_${payload.slug}` : `id_${payload.slug}`
			newLoadingById = {
				...state.loadingById,
				[ theId ]: false
			}
			newById = {
				...state.byId
			}
			newSelected = {
				...state.selected
			}
			newSelectedArchive = {
				...state.selectedArchive
			}
			newPostsSetA = [
				...state.postsSetA
			]
			newPostsSetZ = [
				...state.postsSetZ
			]
			newSermonSeriesSetA = [
				...state.sermonSeriesSetA
			]
			newSermonSeriesSetZ = [
				...state.sermonSeriesSetZ
			]

			if ( newById[ theId ] ) {
				newById[ theId ] = {
					...newById[ theId ],
					...payload.data
				}
			}

			if ( state.selected && payload.slug == state.selected.slug ) {
				newSelected = {
					...state.selected,
					...payload.data
				}
			} else if ( state.selectedArchive ) {
				if ( payload.slug == state.selectedArchive.slug ) {
					newSelectedArchive = {
						...state.selectedArchive,
						...payload.data
					}
				}

				if (
					payload.data.featured_image &&
					newSelectedArchive.items && newSelectedArchive.items[ `id_${payload.slug}` ]
				) {
					newSelectedArchive = {
						...newSelectedArchive,
						items: {
							...newSelectedArchive.items,
							[ `id_${payload.slug}` ]: {
								...newSelectedArchive.items[ `id_${payload.slug}` ],
								...payload.data
							}
						}
					}
				}

				newPostsSetA.map( ( item, index ) => {
					if ( item.slug == payload.slug ) {
						newPostsSetA[ index ] = {
							...item,
							...payload.data
						}
					}
				} )

				newPostsSetZ.map( ( item, index ) => {
					if ( item.slug == payload.slug ) {
						newPostsSetZ[ index ] = {
							...item,
							...payload.data
						}
					}
				} )

				newSermonSeriesSetA.map( ( item, index ) => {
					if ( item.slug == payload.slug ) {
						newSermonSeriesSetA[ index ] = {
							...item,
							...payload.data
						}
					}
				} )

				newSermonSeriesSetZ.map( ( item, index ) => {
					if ( item.slug == payload.slug ) {
						newSermonSeriesSetZ[ index ] = {
							...item,
							...payload.data
						}
					}
				} )
			}

			if ( payload.dkePageData ) {
				dkePageData = {
					...dkePageData,
					...payload.dkePageData
				}
			}

			if ( ! newSelectedArchive || ! Object.keys( newSelectedArchive ).length ) {
				newSelectedArchive = false
			}

			return {
				...state,
				error: false,
				selected: newSelected,
				selectedArchive: newSelectedArchive,
				postsSetA: newPostsSetA,
				postsSetZ: newPostsSetZ,
				sermonSeriesSetA: newSermonSeriesSetA,
				sermonSeriesSetZ: newSermonSeriesSetZ,
				currentlyViewedPage: newSelected,
				byId: newById,
				dkePageData: dkePageData
			}

		case 'RECEIVE_PAGE_ERROR':
			return {
				...state,
				isLoading: false,
				error: true
			}

		case 'SET_CURRENT_PAGE':
			let selected = state.selected,
				selectedArchive = false
			dkePageData = state.dkePageData
			theId = payload.type ? `id_${payload.type}_${payload.slug}` : `id_${payload.slug}`

			if (
				'posts' == payload.type ||
				'events' == payload.type ||
				'sermons' == payload.type ||
				'sermon-series' == payload.type ||
				'speakers' == payload.type ||
				'bulletins' == payload.type ||
				'galleries' == payload.type ||
				'resources' == payload.type ||
				'ministries' == payload.type
				) {

				selected = false

				if ( state.archiveCategoriesById[ theId ] ) {
					selectedArchive = state.archiveCategoriesById[ theId ]
				}

				if ( selectedArchive.dke_page_data ) {
					dkePageData = selectedArchive.dke_page_data
				}
			} else {
				if ( state.byId[ theId ] ) {
					selected = state.byId[ theId ]
				}

				if ( selected.dke_page_data ) {
					dkePageData = selected.dke_page_data
				}

				selectedArchive = false
			}

			return {
				...state,
				selected: selected,
				currentlyViewedPage: selected,
				selectedArchive: selectedArchive,
				appendedById: {},

				numberOfPosts: 0,
				showSetA: false,
				showSetZ: false,
				postsSetA: [],
				postsSetZ: [],

				numberOfSermonSeries: 0,
				showSermonSeriesSetA: false,
				showSermonSeriesSetZ: false,
				sermonSeriesSetA: [],
				sermonSeriesSetZ: [],

				dkePageData: {
					...dkePageData
				}
			}

		case 'SET_CURRENTLY_VIEWED_PAGE':
			let currentlyViewedPage = state.currentlyViewedPage

			if ( state.byId[ 'id_' + payload ] ) {
				currentlyViewedPage = state.byId[ 'id_' + payload ]
			}

			return {
				...state,
				currentlyViewedPage: currentlyViewedPage
			}

		case 'UPDATE_PAGE_VIEWS_REGISTERED':
			return {
				...state,
				pageViewsRegisteredIds: state.pageViewsRegisteredIds.concat( payload )
			}

		case 'APPEND_PAGE':
			let newAppendedById = {
				...state.appendedById
			}

			if ( state.byId[ 'id_' + payload ] ) {
				newAppendedById = {
					...state.appendedById,
					[ 'id_' + payload ]: state.byId[ 'id_' + payload ]
				}
			}

			return {
				...state,
				appendedById: newAppendedById
			}

		case 'SET_ARCHIVE_DATE':
			let newYear = state.selectedDateYear,
				newMonth = state.selectedDateMonth

			if ( payload.year ) {
				newYear = payload.year
			}

			if ( payload.month ) {
				newMonth = payload.month
			}

			return {
				...state,
				selectedDateYear: newYear,
				selectedDateMonth: newMonth
			}

		// Will sort posts into sets, filtering by the selected date.
		case 'MAYBE_UPDATE_POST_SETS':
			if ( ! state.selectedArchive || ! state.selectedArchive.items ) {
				return state
			}

			// Check for potential update conditions:
			let doUpdate = false

			if ( payload.forceUpdate ) {
				doUpdate = true
			}

			const newNumberOfPosts = Object.keys( state.selectedArchive.items ).length
			let  newNumberOfSermonSeries = 0

			if ( state.selectedArchive.sermon_series ) {
				newNumberOfSermonSeries = Object.keys( state.selectedArchive.sermon_series ).length
			}

			if ( ! doUpdate && state.numberOfPosts != newNumberOfPosts ) {
				doUpdate = true
			}

			if ( ! doUpdate ) {
				return state
			}

			const allPosts = state.selectedArchive.items

			let showSetA = false,
				showSetZ = false

			let setANumber = getSetANumber( state.selectedArchive.type )

			if ( newNumberOfPosts == setANumber ) {
				showSetA = true
			} else if ( newNumberOfPosts > setANumber ) {
				showSetA = true
				showSetZ = true
			} else if ( newNumberOfPosts ) {
				showSetZ = true
			}

			let setBStart

			if ( showSetA ) {
				newPostsSetA = Object.keys( allPosts ).slice( 0, setANumber ).map( ( key ) => {
					return allPosts[ key ]
				} )

				setBStart = setANumber
			} else {
				setBStart = 0
			}

			newPostsSetZ = Object.keys( allPosts ).slice( setBStart ).map( ( key ) => {
				let item = allPosts[ key ]

				if (
					( state.selectedDateYear != 'all' && item.date.year != state.selectedDateYear ) ||
					( state.selectedDateYear != 'all' && state.selectedDateMonth != 'all' && item.date.month != state.selectedDateMonth )
				) {
					return null
				}

				return item
			} )

			// Sermon series:
			const allSermonSeries = state.selectedArchive.sermon_series ? state.selectedArchive.sermon_series : false

			let showSermonSeriesSetA = false,
				showSermonSeriesSetZ = false

			let sermonSeriesSetANumber = getSetANumber( 'sermon-series' )

			if ( newNumberOfSermonSeries == sermonSeriesSetANumber ) {
				showSermonSeriesSetA = true
			} else if ( newNumberOfSermonSeries > sermonSeriesSetANumber ) {
				showSermonSeriesSetA = true
				showSermonSeriesSetZ = true
			} else if ( newNumberOfSermonSeries ) {
				showSermonSeriesSetZ = true
			}

			let sermonSeriesSetBStart

			if ( showSermonSeriesSetA ) {
				newSermonSeriesSetA = Object.keys( allSermonSeries ).slice( 0, sermonSeriesSetANumber ).map( ( key ) => {
					return allSermonSeries[ key ]
				} )

				sermonSeriesSetBStart = sermonSeriesSetANumber
			} else {
				sermonSeriesSetBStart = 0
			}

			newSermonSeriesSetZ = Object.keys( allSermonSeries ).slice( sermonSeriesSetBStart ).map( ( key ) => {
				let item = allSermonSeries[ key ]

				if (
					( state.selectedDateYear != 'all' && item.date.year != state.selectedDateYear ) ||
					( state.selectedDateYear != 'all' && state.selectedDateMonth != 'all' && item.date.month != state.selectedDateMonth )
				) {
					return null
				}

				return item
			} )

			// Remove empty:
			if ( newPostsSetA ) {
				newPostsSetA = newPostsSetA.filter( i => i )
			}

			if ( newPostsSetZ ) {
				newPostsSetZ = newPostsSetZ.filter( i => i )
			}

			if ( newSermonSeriesSetA ) {
				newSermonSeriesSetA = newSermonSeriesSetA.filter( i => i )
			}

			if ( newSermonSeriesSetZ ) {
				newSermonSeriesSetZ = newSermonSeriesSetZ.filter( i => i )
			}

			return {
				...state,
				numberOfPosts: newNumberOfPosts,
				showSetA: showSetA,
				showSetZ: showSetZ,
				postsSetA: newPostsSetA,
				postsSetZ: newPostsSetZ,

				numberOfSermonSeries: newNumberOfSermonSeries,
				showSermonSeriesSetA: showSermonSeriesSetA,
				showSermonSeriesSetZ: showSermonSeriesSetZ,
				sermonSeriesSetA: newSermonSeriesSetA,
				sermonSeriesSetZ: newSermonSeriesSetZ
			}

		/**
		 * Featured image
		 */

		case 'RECEIVE_FEATURED_IMAGE':
			newSelected = state.selected
			newSelectedArchive = state.selectedArchive

			if ( state.selected ) {
				newSelected = {
					...state.selected,
					featured_image: payload
				}
			} else if ( state.selectedArchive ) {
				newSelectedArchive = {
					...state.selectedArchive,
					featured_image: payload
				}
			}

			return {
				...state,
				selected: newSelected,
				currentlyViewedPage: newSelected,
				selectedArchive: newSelectedArchive,
			}

		/**
		 * Social
		 */

		case 'RECEIVE_FACEBOOK_FEED':
			return {
				...state,
				facebookFeedById: payload,
				facebookFeedReceived: true
			}

		case 'RECEIVE_INSTAGRAM_FEED':
			return {
				...state,
				instagramFeedById: payload,
				instagramFeedReceived: true
			}

		/**
		 * Images
		 */

		case 'RECEIVE_DKE_SECTION_IMAGE_UPDATED':
			newSelected = state.selected
			prevSectionsData = {},
			prevSectionData = {}

			if ( state.selected[ payload.content_id ] ) {
				prevSectionsData = state.selected[ payload.content_id ]
			}

			if ( prevSectionsData[ payload.section_id ] ) {
				prevSectionData = prevSectionsData[ payload.section_id ]
			}

			newSectionsData = {
				...prevSectionsData,
				[ payload.section_id ]: {
					...prevSectionData,
					[ payload.section_data_id ]: {
						id: '',
						url: '',
						alt: '',
						aspect_ratio: '',
						focal_point: '',
						width: '',
						height: '',
						thumb: '',
						srcset: '',
						...payload.image
					}
				}
			}

			newSelected = {
				...state.selected,
				[ payload.content_id ]: newSectionsData
			}

			return {
				...state,
				selected: newSelected
			}

			return {
				...state,
				selected: newSelected
			}

		/**
		 * Image galleries
		 */

		case 'RECEIVE_DKE_SECTION_IMAGE_GALLERY_UPDATED':
			newSelected = state.selected
			prevSectionsData = {},
			prevSectionData = {}

			if ( state.selected[ payload.content_id ] ) {
				prevSectionsData = state.selected[ payload.content_id ]
			}

			if ( prevSectionsData[ payload.section_id ] ) {
				prevSectionData = prevSectionsData[ payload.section_id ]
			}

			newSectionsData = {
				...prevSectionsData,
				[ payload.section_id ]: {
					...prevSectionData,
					[ payload.section_data_id ]: {
						items: {},
						...payload.image_gallery
					}
				}
			}

			newSelected = {
				...state.selected,
				[ payload.content_id ]: newSectionsData
			}

			return {
				...state,
				selected: newSelected
			}

		/**
		 * Links
		 */

		case 'RECEIVE_DKE_SECTION_LINK_UPDATED':
			newSelected = state.selected
			prevSectionsData = {},
			prevSectionData = {}

			if ( state.selected[ payload.content_id ] ) {
				prevSectionsData = state.selected[ payload.content_id ]
			}

			if ( prevSectionsData[ payload.section_id ] ) {
				prevSectionData = prevSectionsData[ payload.section_id ]
			}

			newSectionsData = {
				...prevSectionsData,
				[ payload.section_id ]: {
					...prevSectionData,
					[ payload.section_data_id ]: {
						url: payload.link.url,
						text: payload.link.text
					}
				}
			}

			newSelected = {
				...state.selected,
				[ payload.content_id ]: newSectionsData
			}

			return {
				...state,
				selected: newSelected
			}

		/**
		 * Forms
		 */

		case 'RECEIVE_DKE_SECTION_FORM_UPDATED':
			newSelected = state.selected
			prevSectionsData = {},
			prevSectionData = {}

			if ( state.selected[ payload.content_id ] ) {
				prevSectionsData = state.selected[ payload.content_id ]
			}

			if ( prevSectionsData[ payload.section_id ] ) {
				prevSectionData = prevSectionsData[ payload.section_id ]
			}

			newSectionsData = {
				...prevSectionsData,
				[ payload.section_id ]: {
					...prevSectionData,
					[ payload.section_data_id ]: payload.form_data
				}
			}

			newSelected = {
				...state.selected,
				[ payload.content_id ]: newSectionsData
			}

			return {
				...state,
				selected: newSelected
			}

		/**
		 * Maps
		 */

		case 'RECEIVE_DKE_SECTION_MAP_UPDATED':
			newSelected = state.selected
			prevSectionsData = {},
			prevSectionData = {}

			if ( state.selected[ payload.content_id ] ) {
				prevSectionsData = state.selected[ payload.content_id ]
			}

			if ( prevSectionsData[ payload.section_id ] ) {
				prevSectionData = prevSectionsData[ payload.section_id ]
			}

			newSectionsData = {
				...prevSectionsData,
				[ payload.section_id ]: {
					...prevSectionData,
					[ payload.section_data_id ]: payload.map_data
				}
			}

			newSelected = {
				...state.selected,
				[ payload.content_id ]: newSectionsData
			}

			return {
				...state,
				selected: newSelected
			}

		/**
		 * Sections
		 */

		case 'RECEIVE_DKE_SECTION_ADDED':
			newSelected = state.selected
			prevSectionsData = {}

			if ( state.selected[ payload.data.content_id ] ) {
				prevSectionsData = state.selected[ payload.data.content_id ]
			}

			if ( payload.data.previous_id ) {
				// Add into correct position:
				newSectionsData = insertIntoObjectAfterKey( prevSectionsData, payload.id, payload.data, payload.data.previous_id )
			} else {
				// Add to start:
				newSectionsData = {
					[ payload.id ]: payload.data,
					...prevSectionsData
				}
			}

			newSelected = {
				...state.selected,
				[ payload.data.content_id ]: newSectionsData
			}

			return {
				...state,
				selected: newSelected
			}

		case 'RECEIVE_DKE_SECTION_REMOVED':
			newSelected = state.selected
			prevSectionsData = {}

			if ( state.selected[ payload.content_id ] ) {
				prevSectionsData = state.selected[ payload.content_id ]
			}

			// Get the section data without the removed key, as newSectionsDataAfterRemoval:
			let {
				[ payload.section_id ]: _,
				...newSectionsDataAfterRemoval
			} = prevSectionsData

			newSelected = {
				...state.selected,
				[ payload.content_id ]: newSectionsDataAfterRemoval
			}

			return {
				...state,
				selected: newSelected
			}

		case 'RECEIVE_DKE_SECTION_REORDERED':
			newSelected = state.selected
			prevSectionsData = {}
			prevSectionsKeys = []
			newSectionsKeys = []
			let sortedSectionsArray = payload.sections_array

			// Get existing data/keys:
			if ( state.selected[ payload.content_id ] ) {
				prevSectionsData = state.selected[ payload.content_id ]
				prevSectionsKeys = Object.keys( prevSectionsData )
			}

			// Sort the existing data, based on the order of the provided sections:
			sortedSectionsArray.forEach( section => {
				let found = false

				prevSectionsKeys.filter( key => {
					if ( found ) {
						return true
					}

					if ( key == section.id ) {
						newSectionsKeys.push( key )
						found = true

						return false
					}
				} )
			} )

			// Convert array of keys to the full sections object:
			newSectionsData = newSectionsKeys.reduce( ( acc, currentKey ) => {
				acc[ currentKey ] = prevSectionsData[ currentKey ]

				return acc
			}, {} )

			newSelected = {
				...state.selected,
				[ payload.content_id ]: newSectionsData
			}

			return {
				...state,
				selected: newSelected
			}

		case 'RECEIVE_DKE_SECTION_SETTINGS':
			newSelected = state.selected
			prevSectionsData = {},
			prevSectionData = {}

			if ( state.selected[ payload.content_id ] ) {
				prevSectionsData = state.selected[ payload.content_id ]
			}

			if ( prevSectionsData[ payload.section_id ] ) {
				prevSectionData = prevSectionsData[ payload.section_id ]
			}

			newSectionsData = {
				...prevSectionsData,
				[ payload.section_id ]: {
					...prevSectionData,
					settings: payload.data
				}
			}

			newSelected = {
				...state.selected,
				[ payload.content_id ]: newSectionsData
			}

			return {
				...state,
				selected: newSelected
			}
	}

	return state
}
